import * as Interfaces from 'interfaces';
import { transformMobileInt } from '../../utils/validations';

export function getStreetAddress(fullAddress?: string): string {
  if (!fullAddress) return '';
  if (!fullAddress.includes(',')) return fullAddress;
  const strAddress: string[] = fullAddress.split(',');
  strAddress.splice(strAddress?.length - 1, 1);
  return strAddress.join(',');
}

export function serializeForm(
  values: Interfaces.Common.FormValues,
  transactionId: string
): Interfaces.API.ApiVoucherSubmit {
  return {
    proofType: values.identity.proofType,
    cardNo: values.identity.cardNo,
    dob: values.identity.dob,
    givenName: values.identity.givenName,
    familyName: values.identity.familyName,
    middleName: values.identity.middleName,
    email: values.identity.email,
    mobileNumber: transformMobileInt(values.identity.mobileNumber),
    consentDeclared: values.review.consentDeclared,
    abnNo: values.abn.number.replace(/\s/g, ''),
    address: JSON.stringify(values.abn.address),
    businessName: values.abn.optionalBusinessName ?? '',
    abnOrganizationName: values.abn?.name ?? '',
    transactionId,
    // note - checks are done beforehand to verify this exists
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    voucherType: values.abn.voucherType!
  };
}
